import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

let csrfToken = null;
let csrfTokenRequest = null;

async function getCsrfToken() {
  if (csrfToken) return csrfToken;
  if (!csrfTokenRequest) {
    csrfTokenRequest = axios
      .get(`${API}/auth/csrf`, { withCredentials: true })
      .then(({ data }) => {
        csrfToken = data?.csrf_token || null;
        if (!csrfToken) throw new Error("A API não retornou o token CSRF.");
        return csrfToken;
      })
      .finally(() => {
        csrfTokenRequest = null;
      });
  }
  return csrfTokenRequest;
}

// Cross-origin JavaScript cannot read the API host's cookie. Obtain the
// matching non-authentication token through the CORS-protected bootstrap route.
api.interceptors.request.use(async (config) => {
  const method = (config.method || "get").toLowerCase();
  const isLogin = config.url?.replace(/\/+$/, "").endsWith("/auth/login");
  if (!isLogin && !["get", "head", "options"].includes(method)) {
    const csrf = await getCsrfToken();
    config.headers["X-CSRF-Token"] = csrf;
  }
  return config;
});

api.interceptors.response.use((response) => {
  const url = response.config.url?.replace(/\/+$/, "");
  if (url?.endsWith("/auth/login") && response.data?.csrf_token) {
    csrfToken = response.data.csrf_token;
  } else if (url?.endsWith("/auth/logout")) {
    csrfToken = null;
  }
  return response;
});

export function formatApiError(detail) {
  if (detail == null) return "Ocorreu um erro. Tente novamente.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e?.msg ? e.msg : JSON.stringify(e))).join(" ");
  if (detail?.msg) return detail.msg;
  return String(detail);
}
